import APIModel from "../APIModel";

export default class Clients extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "applications";
  }

  async getData(params: any = {}): Promise<any> {
    return await this.http.get(`${this.resourceUrl}`, params);
  }

  async getForEdit(id: number): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getList(): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/list`, {});
  }

  async show(headers: any = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500, 404)
      .get(`${this.resourceUrl}/show`, {}, headers);
  }

  async preview(headers: any = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500, 404)
      .get(`${this.resourceUrl}/preview`, {}, headers);
  }

  async edit(id: string, payload: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .useFormData()
      .post(`${this.resourceUrl}/${id}?_method=PATCH`, payload);
  }

  async create(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .useFormData()
      .post(`${this.resourceUrl}`, payload);
  }

  async delete(id: any): Promise<any> {
    return await this.http.delete(`${this.resourceUrl}`, { id });
  }

  async abiturientConfirm(id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(301)
      .patch(`${this.resourceUrl}/${id}/confirm`, {});
  }

  async printApplication(id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(404, 403, 500, 401)
      .get(`${this.resourceUrl}/${id}/print`, {});
  }

  async printEnrolled(id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(404, 403, 500, 401)
      .get(`${this.resourceUrl}/${id}/print_enrolled`, {});
  }
}
